<script lang="ts">
  import { Link, navigate } from "svelte-routing";

  import { NavigationDrawer, List, ListItem, ListItemGroup, Icon, Subheader, Divider } from 'svelte-materialify/src';
  import { mdiViewDashboard, mdiAccountBox, mdiGavel } from '@mdi/js';

  import patterns from './pattern/pattern-library';

  // props
  export let show: boolean = false;
  export let setCurrentPatternId: CallableFunction;
  // export let closeSideBar: CallableFunction;

  // let showSideBar = false;
  // let isSmallDevice = false;

  // const onResize = () => {
  //   isSmallDevice = window.matchMedia('(max-width: 600px)').matches;
  //   console.log('isSmallDevice', isSmallDevice);
  //   updateShowSideBar();
  // };

  // const updateShowSideBar = () => {
  //   showSideBar = !isSmallDevice || show;
  //   console.log('updateShowSideBar?', showSideBar, 'isSmallDevice?',isSmallDevice, 'show?', show);
  // }

  // $: updateShowSideBar();
</script>

<!-- <svelte:window on:resize={onResize} /> -->

<div> 
  <NavigationDrawer active={show} fixed style="height: 100vh; padding-top: 50px;" >
    <List dense class="elevation-2" style="width:300px">

<!--      <Subheader>Pages</Subheader>-->
<!--      <ListItem on:click={() => { navigate("/"); closeSideBar(); }}>-->
<!--        <Link to="/" >Home</Link>-->
<!--      </ListItem>-->
<!--      <ListItem on:click={() => { navigate("/imprint"); closeSideBar(); }}>-->
<!--        <Link to="/" >Imprint</Link>-->
<!--      </ListItem>-->
<!--      <Divider />-->

      <Subheader>Patterns</Subheader>
      <ListItemGroup class="blue-text" value={[1]}>
        {#each patterns as pattern}
        <ListItem on:click={() => setCurrentPatternId(pattern.id)}>
          {pattern.name}
        </ListItem>
        {/each}
      </ListItemGroup>
    </List>

    <span slot="append" class="pa-2">
      <div class="font-weight-thin text--secondary" style="font-size: smaller;">
        Hint: The pattern library is not complete yet, still in development.
      </div>
    </span>

    

  </NavigationDrawer>
</div>
